interface Param {
  birthday: string;
  firstName: string;
  firstNameReading: string;
  gender: number;
  lastName: string;
  lastNameReading: string;
  optin: boolean;
}

const defaultParams: Param = {
  birthday: '',
  firstName: '',
  firstNameReading: '',
  gender: 0,
  lastName: '',
  lastNameReading: '',
  optin: false,
};

export class UserProfile {
  birthday: string;
  firstName: string;
  firstNameReading: string;
  gender: number;
  lastName: string;
  lastNameReading: string;
  optin: boolean;

  constructor(params: Param = defaultParams) {
    this.birthday = params.birthday;
    this.firstName = params.firstName;
    this.firstNameReading = params.firstNameReading;
    this.lastName = params.lastName;
    this.lastNameReading = params.lastNameReading;
    this.gender = params.gender;
    this.optin = params.optin;
  }

  getFullName(): string {
    return `${this.lastName}${this.firstName}`;
  }
}
